<ng-template #attachedDataItemTemplate let-item="item">
  {{ item.name }}
</ng-template>
<ng-template #attachedDataSelectionTemplate let-selection="selection">
  {{ selection[0].name }}
</ng-template>

<input
  #fileInput
  id="fileSelector"
  type="file"
  class="d-none"
  (click)="$event.target.value = ''"
  (change)="onFileChange($event.target.files)"
  accept="{{ acceptFileExtensions.join(',') }}" />

<div class="container">
  <div class="row mt-4">
    <label for="dateSelector" class="col-form-label col-3 form-label">
      {{ '::DateRange' | abpLocalization }}
    </label>
    <div class="col">
      <ca-date-selection-panel
        #dateSelector
        [config]="dateSelectionConfiguration"></ca-date-selection-panel>
    </div>
  </div>
  <div class="row mt-2">
    <label class="col-form-label col-3 form-label pe-2">
      {{ 'Conversation::TaggingCriteria' | abpLocalization }}
    </label>
    <div class="col justify-content-start align-items-center" [formGroup]="criteriaForm">
      <div class="row mt-2">
        <div class="col-auto">
          <div class="d-flex justify-content-start">
            <input
              id="attachedDataRadio"
              type="radio"
              formControlName="criteria"
              [value]="batchTaggingCriteriaType.AttachedData" />
            <label for="attachedDataRadio" class="radio-label me-1 ms-2">
              {{ '::AttachedData' | abpLocalization }}
            </label>
          </div>
        </div>
        <div class="col">
          <div class="d-flex justify-content-center">
            <input
              id="calledOrCallerNumberRadio"
              type="radio"
              formControlName="criteria"
              [value]="batchTaggingCriteriaType.CalledCallerNumber" />
            <label for="calledOrCallerNumberRadio" class="radio-label me-1 ms-2">
              {{ 'Conversation::CalledOrCallerNumber' | abpLocalization }}
            </label>
          </div>
        </div>
        <div class="col-auto">
          <div class="d-flex justify-content-end">
            <input
              id="conversationIdRadio"
              type="radio"
              formControlName="criteria"
              [value]="batchTaggingCriteriaType.ConversationId" />
            <label for="conversationIdRadio" class="radio-label me-1 ms-2">
              {{ 'Conversation::ConversationId' | abpLocalization }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2" [hidden]="!isAttachedData">
    <label for="attachedDataSelector" class="col-form-label col-3 form-label">
      {{ '::AttachedData' | abpLocalization }}
    </label>
    <div class="col" [formGroup]="attachedDataForm">
      <ca-attached-data-selector
        [bringToFront]="true"
        formControlName="attachedData"
        placeholder="{{ '::PleaseSelect' | abpLocalization }}..."></ca-attached-data-selector>
    </div>
  </div>
  <div class="row mt-2">
    <label class="col-form-label col-3 form-label">{{ '::File' | abpLocalization }}</label>
    <div class="col">
      <button class="btn ca-btn ca-btn-neutral" type="button" (click)="fileInput.click()">
        <i class="far fa-upload"></i>
        <span>{{ '::UploadFile' | abpLocalization }}...</span>
      </button>
      <span class="ms-2" *ngIf="selectedCsvFile?.size > 0">
        {{ selectedCsvFile?.name }}, {{ (selectedCsvFile.size / 1024).toFixed(2) }} KB
      </span>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-3"></div>
    <div class="col pe-0">
      <small
        innerHtml="{{
          'Conversation::UploadTaggingStepInfo' | abpLocalization : strMaxCsvFileSize
        }}"></small>
    </div>
  </div>
  <div class="row mt-1">
    <div class="col-3"></div>
    <div class="col">
      <small
        innerHtml="{{
          'Conversation::UploadTaggingStepInfoDetail' | abpLocalization : strMaxCsvFileSize
        }}"></small>
    </div>
  </div>
</div>
